import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { TimeClock } from '../types'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type DeleteTimeClockWorkflow = {
  open: (timeClock: TimeClock) => void
  close: () => void
  isOpen: boolean
  timeClock: TimeClock | null
}

export type TimeClocksWorkflowsContextState = {
  createTimeClockFlow: Workflow
  deleteTimeClockFlow: DeleteTimeClockWorkflow
}

const [TimeClocksWorkflowsContext, useTimeClocksWorkflowsContextValue] =
  createContext<TimeClocksWorkflowsContextState>({
    name: 'TimeClocksWorkflowsContext',
  })

export const TimeClocksWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCreateTimeClockFlowOpen, setIsCreateTimeClockFlowOpen] =
    useState(false)
  const [isDeleteTimeClockFlowOpen, setIsDeleteTimeClockFlowOpen] =
    useState(false)
  const [deleteTimeClock, setDeleteTimeClock] = useState<TimeClock | null>(null)

  const value: TimeClocksWorkflowsContextState = {
    createTimeClockFlow: {
      open: () => setIsCreateTimeClockFlowOpen(true),
      close: () => setIsCreateTimeClockFlowOpen(false),
      isOpen: isCreateTimeClockFlowOpen,
    },
    deleteTimeClockFlow: {
      open: (timeClock: TimeClock) => {
        setDeleteTimeClock(timeClock)
        setIsDeleteTimeClockFlowOpen(true)
      },
      // Keep the selected time clock so the modal close animation isn't cut short.
      close: () => setIsDeleteTimeClockFlowOpen(false),
      isOpen: isDeleteTimeClockFlowOpen,
      timeClock: deleteTimeClock,
    },
  }

  return (
    <TimeClocksWorkflowsContext.Provider value={value}>
      {children}
    </TimeClocksWorkflowsContext.Provider>
  )
}

export { useTimeClocksWorkflowsContextValue }
